import {
  buildHeader,
  buildParagraph,
  buildNewlines,
  buildTextRun,
} from "./helpers";

const createSectionPersonalizedInterventionPlan = (studentData, weeklyPlan) => [
  // Personalized Intervention Plan
  buildHeader(`${studentData.firstName}'s Personalized Intervention Plan`, 3),
  // Personalized Intervention Plan Summary
  buildTextRun([
    {
      text: `[TODO] [Mock: `,
    },
    {
      text: `Tier I:`,
      bold: true,
    },
    {
      text: ` The student receives Tier I grade-level core reading instruction with peers that is explicit, evidence-based, and culturally responsive.]`,
    },
  ]),
  ...buildNewlines(2),
  // Personalized Intervention Plan Table
  buildParagraph(`[TODO] Implement the graphics / tables`, { italics: true }),
  ...buildNewlines(2),
];

export default createSectionPersonalizedInterventionPlan;
